<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">{{ title }}</h5>
                <p class="mb-0 text-sm">{{ description }}</p>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <hk-btn-upload-modal :options-format="formatsFile" :url="urlUpload" @success="importSuccess" @failure="importFailure" />
                  <FilterDate :value-date=filters.date @filter-change="onDateFilterChange" @clean-filter-date="onCleanFilterDate"/>
                  <Filter :filter-status-selected="filterStatusSelected" @filter-change="onFilterChange"/>
                  <SgaRegisteredFilter :filter-sga-registered="filters.sga_registered" @sga-registered-filter-change="onFilterSgaRegisteredChange"/>
                  <soft-button class="btn-icon ms-2 export" size color="primary" variant="outline" data-type="csv" @click="onDownloadExcel">
                    <span class="btn-inner--icon">
                      <i class="fa-solid fa-file-download me-2"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_purchaseListTableHeader_button_export_purchase') }}</span>
                  </soft-button>
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_purchaseListTableHeader_button_reload_purchase')" @change="getPurchases"/>
                </div>
              </div>
              <div class="mt-4 mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Search space -->
                  <Searchbox :list-filters="listFilters" @change="onSearchChange"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabla con los Datos -->
          <GenericTable
            v-if="!!comprasData"
            ref="genericTable"
            :items="comprasData.items"
            :list-filters="listFilters"
            :pagination="pagination"
            :headers="headers"
            :is-loading="isLoading"
            @header-changed="onHeaderChange"
            @changed-page="paginationPageChange"
            @row-change="paginationRowChange">
            <template #row="compra">
              <td style="width: 5rem">
                <div class="d-flex align-items-center">
                  <a style="cursor:pointer" class="mx-3" :title="$t('key_purchaseList_viewFiles')" data-bs-toggle="modal" data-bs-target="#uploadFolder" @click="loadResource(compra)">
                    <i v-if="compra.with_resource && compra.with_resource == true" class="fa-solid fa-folder-plus text-warning"></i>
                    <i v-else class="fa-solid fa-folder-open text-warning"></i>
                  </a>
                  <FileModalSelector
                    data-bs-backdrop="static"
                    :resources='purchaseResource'
                    :entity-id='entityId'
                    :entity-number='entityNumber'
                    :errors='purchaseErrorDocument'
                    :url='urlUploadResource'
                    @success-upload='uploadedResource'
                    @remove-item='removeResource'
                    @close-modal='getPurchases'
                  />
                </div>
              </td>
              <td style="width: 20rem" class="text-xs cursor-pointer font-weight-bolder mb-0 picko-link">
                <div class="d-flex">
                  <!-- <div class="my-auto form-check">
                    <input :id="item.id" class="form-check-input" type="checkbox" :checked="selectedIds.includes(item.id)" @change="changedSelection(item.id)" >
                  </div> -->
                  <a class="my-auto ms-3 picko">
                    <a class="font-weight-bold text-primary" href="#" @click.prevent="goToDetalle(compra)">
                      <i
                          v-if="compra.sga_registered === false"
                          class="fa-solid fa-triangle-exclamation text-danger me-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          data-bs-original-title="Not synced to SGA yet"
                      ></i>
                      {{ compra.number }}
                    </a>
                  </a>
                </div>
              </td>
              <!-- <td style="width: 15rem" class="text-sm font-weight-bold">
                <a class="cursor-pointer font-weight-bold font-weight-bold mb-0 picko-link" :title="$t('key_purchaseList_viewPurchase')" @click="goToDetalle(compra)">
                  {{compra.number}}
                </a>
              </td> -->
              <!-- <td class="text-xs font-weight-bold">
                <span class="my-2 text-xs columns">{{ compra.reference }}</span>
              </td> -->
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ $dateUtils.toDDMMYYYY(compra.date) }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="compra.status == 'CANCELADO'" class="badge badge-cancelled badge-sm">{{ $t('key_purchaseList_purchaseCancelled') }}</span>
                <span v-else-if="compra.status == 'FINALIZADO'" class="badge badge-located badge-sm">{{ $t('key_purchaseList_purchaseFinished') }}</span>
                <span v-else-if="compra.status == 'EN_PROCESO'" class="badge badge-processing badge-sm">{{ $t('key_purchaseList_purchaseInProcess') }}</span>
                <span v-else-if="compra.status == 'REGISTRADO'" class="badge badge-saved badge-sm">{{ $t('key_purchaseList_purchaseSaved') }}</span>
                <span v-else-if="compra.status == 'RETENIDO'" class="badge badge-onhold badge-sm">{{ $t('key_orderStatus_onhold') }}</span>
                <span v-else class="badge badge-error badge-sm" :title="compra.errors">{{ $t('key_purchaseList_purchaseError') }}</span>
              </td>
              <td  class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ compra.end_customer.name }}</span>
              </td>
              <td class="units text-xs font-weight-bold">
                <ul>
                  <li><span class="my-2 text-xs text-info">{{ $t('key_purchaseList_informed') }}: {{ $numberFormat.toDecimalFormat(compra.units.requested) }}</span></li>
                  <li><span class="my-2 text-xs text-success">{{ $t('key_purchaseList_located') }}: {{ $numberFormat.toDecimalFormat(compra.units.completed) }}</span></li>
                </ul>
              </td>
              <!-- <td class="font-weight-bold">
                <span v-if="compra.batch_control" class="badge badge-info badge-sm">{{ $t('key_purchaseList_batchControl') }}</span>
              </td>
              <td class="font-weight-bold">
                <span v-if="compra.batch_control_date" class="badge badge-info badge-sm">{{ $t('key_purchaseList_batchControlDate') }}</span>
              </td> -->
              <td class="font-weight-bold">
                <span class="my-2 text-xs columns">{{ $dateUtils.toDDMMYYYYHH(compra.created_at) }}</span>
              </td>
              <td class="text-xs font-weight-bold">
                <a v-show="compra.status == 'REGISTRADO' || compra.status == 'RETENIDO'"
                  style="cursor:pointer"
                  class="mx-3"
                  :title="compra.on_hold ? $t('key_purchase_purchaseAvailable') : $t('key_purchase_purchaseOnHold')"
                  data-bs-toggle="modal"
                  data-bs-target="#onHoldModal"
                  @click="onHoldModalData = { ...compra }">
                  <i :class="{ 'fa-solid fa-pause text-warning': !compra.on_hold, 'fa-solid fa-play text-primary': compra.on_hold }"></i>
                </a>
                <a v-show="compra.status == 'NO_REGISTRADO' || compra.status == 'REGISTRADO' || compra.status == 'RETENIDO'"
                  style="cursor:pointer"
                  class="mx-3"
                  :title="$t('key_purchaseList_cancelPurchase')"
                  data-bs-toggle="modal"
                  data-bs-target="#cancelEntityModal"
                  @click="() => entityId = compra._id">
                  <i class="fa-solid fa-times text-danger"></i>
                </a>
                <a v-show="compra.status == 'CANCELADO'"
                  style="cursor:pointer"
                  class="mx-3 icon-danger"
                  :title="$t('key_purchaseList_recoverPurchase')"
                  data-bs-toggle="modal"
                  data-bs-target="#recoverEntityModal"
                  @click="() => entityId = compra._id">
                  <i class="fa-solid fa-arrow-rotate-left text-info"></i>
                </a> 
              </td>
            </template>
          </GenericTable>

        </div>
      </div>
    </div>
  </div>
  <ModalCancelConfirmation :entity-id='entityId' @cancel-entity="cancelEntity" />
  <ModalRecoverConfirmation :entity-id='entityId' @recover-entity="recoverEntity" />
  <ModalOnHold :on-hold-modal-data='onHoldModalData' @confirm-on-hold-status="confirmOnHoldStatus" />
  <div class="position-fixed top-8 end-2 z-index-2">
    <soft-snackbar
      :show="showNotification"
      :title="notificationInfo.title"
      :description="notificationInfo.message"
      :icon="{ component: notificationInfo.status=='success'?'ni ni-check-bold':'ni ni-fat-remove' , color: notificationInfo.status=='success'?'success':'danger' }"
      :color="notificationInfo.status=='success'?'success':'danger'"
      @close-handler="showNotification = !showNotification"
    />
  </div>
</template>

<script>

  import GenericTable from "./../../picko_components/generic_components/GenericTable.vue";
  import ReloadButton from "./../../picko_components/generic_components/ReloadButton.vue";
  import Searchbox from "./../../picko_components/generic_components/Searchbox.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import ModalCancelConfirmation from "@/components/ModalCancelConfirmation.vue";
  import ModalRecoverConfirmation from "@/components/ModalRecoverConfirmation.vue";
  import ModalOnHold from "@/components/ModalOnHold.vue";
  import { HkBtnUploadModal, FileModalSelector } from "@/hotaka/components";
  import SoftSnackbar from "@/components/SoftSnackbar.vue";
  import Filter from "./components/Filter.vue";
  import FilterDate from "../../components/FilterDate.vue";
  import Cookies from 'js-cookie';
  import SgaRegisteredFilter from "@/components/SgaRegisteredFilter.vue";
  import setTooltip from "@/assets/js/tooltip.js";

  export default {
    name: "PurchaseList",
    components: {
      SgaRegisteredFilter,
      SoftButton,
      HkBtnUploadModal,
      SoftSnackbar,
      Filter,
      FileModalSelector,
      ModalCancelConfirmation,
      ModalRecoverConfirmation,
      ModalOnHold,
      FilterDate,
      GenericTable,
      ReloadButton,
      Searchbox
    },
    data() {
      return {
        filterStatusSelected: '',
        pagination: {
          total: 0,
          rows: 10,
          currentPage: 1,
          pages: {
            total: 10,
            current: 1
          },
          entries: [5, 10, 15, 20, 50]
        },
        formatsFile:[
          { label: 'Sevica V2',value: 'SEVICA_V2'},
          { label: 'Sevica',value: 'SEVICA'},        
        ],
        urlUpload:"/purchase/batch",
        urlUploadResource: "purchase",
        entityId: null,
        entityNumber: null,
        notificationInfo:{
          title: '',
          message: '',
          status: 'danger'
        },
        isLoading: false,
        showNotification: false,
        filters:{
          search: '',
          status:'',
          sort:{
            sort:'',
            order:''
          },
          date: {
            start: '',
            end: ''
          },
          sga_registered: '',
        },
        onHoldModalData: {}
      };
    },
    computed: {
      comprasData() {
        return this.$store.state.purchase.list.data;
      },
      purchasesExcel() {
        return this.$store.state.purchase.purchasesExcel.data;
      },
      purchaseResource() {
        return this.$store.state.purchase.purchaseResource.data;
      },
      purchaseErrorDocument() {
        return this.$store.state.purchase.purchaseResource.error;
      },
      cancel() {
        return this.$store.state.purchase.cancelEntity.status;
      },
      recover() {
        return this.$store.state.purchase.recoverEntity.status;
      },
      onHoldStatus() {
        return this.$store.state.purchase.onHoldStatus.status;
      },
      listFilters() {
        return this.$store.state.purchase.listFilters;
      },
      headers() {
        return [
          { title: this.$t('key_theader_PurchaseList_files'), sort: { sorteable: true, order: '' }, column: "with_resource" },
          { title: this.$t('key_theader_PurchaseList_number'), sort: { sorteable: true, order: '' }, column: 'number' },
          /* { title: this.$t('key_theader_PurchaseList_reference'), sort: { sorteable: true, order: '' }, column: 'reference' }, */
          { title: this.$t('key_theader_PurchaseList_entryDate'), sort: { sorteable: true, order: '' }, column: 'date' },
          { title: this.$t('key_theader_PurchaseList_status'), sort: { sorteable: true, order: '' }, column: 'status' },
          { title: this.$t('key_theader_PurchaseList_end_customer'), sort: { sorteable: true, order: '' }, column: 'end_customer' },
          { title: this.$t('key_theader_PurchaseList_units'), sort: { sorteable: true, order: '' }, column: 'units' },
          /* { title: this.$t('key_theader_PurchaseList_batch_control'), sort: { sorteable: true, order: '' }, column: 'batch_control' },
          { title: this.$t('key_theader_PurchaseList_batch_control_date'), sort: { sorteable: true, order: '' }, column: 'batch_control_date' }, */
          { title: this.$t('key_theader_PurchaseList_created_on'), sort: { sorteable: true, order: '' }, column: 'created_at' },
          { title: this.$t('key_theader_PurchaseList_actions'), sort: { sorteable: false, order: ''}, }
        ]
      },
      title() {
        return this.$t('key_purchaseList_table_title');
      },
      description() {
        return this.$t('key_purchaseList_table_description');
      }
    },
    watch: {
      cancel(val) {
        if (val.canceled) {
          if (this.$store.state.purchase.cancelEntity.data) {
            this.notificationInfo = {
              title: this.$t('key_mheader_purchase_cancelled'),
              message: this.$t('key_mmessage_purchase_cancelled'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getPurchases();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      recover(val) {
        if (val.recovered) {
          if (this.$store.state.purchase.recoverEntity.data) {
            this.notificationInfo = {
              title: this.$t('key_mheader_purchase_recovered'),
              message: this.$t('key_mmessage_purchase_recovered'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getPurchases();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      onHoldStatus(val) {
        if (val.onHoldStatus) {
          if (this.$store.state.purchase.onHoldStatus.data) {
            this.notificationInfo = {
              title: this.onHoldModalData.on_hold ? this.$t('key_mheader_purchase_available') : this.$t('key_mheader_purchase_on_hold'),
              message: this.onHoldModalData.on_hold ? this.$t('key_mmessage_purchase_available') : this.$t('key_mmessage_purchase_on_hold'),
              status: 'success'
            }
            this.showNotification = true;
            this.closeNotification()
            setTimeout(() => {
              this.getPurchases();
            }, 1000);
          }
        } else if (val.error) {
          this.showNotification = true;
          this.notificationInfo = {
            title: 'Ups! Error',
            message: val.error.error,
            status: 'error'
          }
          this.closeNotification()
        }
      },
      comprasData() {
        if(this.comprasData){
          this.pagination.total= this.comprasData.total;
          this.isLoading = false;
          this.$nextTick(() => {
            setTooltip(this.$store.state.bootstrap);
          });
        }
      },
      purchasesExcel() {
        if (this.$store.state.purchase.purchasesExcel.error) {
          const error = this.$store.state.purchase.purchasesExcel.error;
          const fr = new FileReader();
          fr.onload = (e) => {
            let excelError = JSON.parse(e.target.result);
            this.notificationInfo = {
              title: 'Ups! Error',
              message: excelError,
              status: 'error'
            }
            this.showNotification = true;
            this.closeNotification();
          };
          fr.readAsText(error);
        }
        else{
          this.downloadExcel(this.purchasesExcel);
          return;
        }
      },
    },
    mounted() {
      this.setUpFilters()
      if (Object.keys(this.$route.query).length > 0) {
        this.filterStatusSelected = this.$route.query.status
        this.filters.status = this.$route.query.status;
      }
      this.getPurchases();
    },
    methods: {
      setUpFilters() {
        if (Object.keys(this.listFilters).length == 0) {
          this.defaultRangeDate()
          return
        }

        this.filters = { ...JSON.parse(JSON.stringify(this.listFilters['filters'])) }
        this.pagination = { ...JSON.parse(JSON.stringify(this.listFilters.pagination)) }
        this.headers = this.headers.map(header => {
          let newHeader = { ...header }

          if (this.filters.sort.sort == header.column) {
            newHeader.sort.order = this.filters.sort.order == 'descending' ? 'desc' : 'asc'
          }

          return newHeader
        })
      },
      defaultRangeDate(){
        const fecha = new Date();
    
        const from90 = new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()-90
        );
        const today= new Date(
          fecha.getFullYear(),
          fecha.getMonth(),
          fecha.getDate()
        );
        
        this.filters.date.start=this.$dateUtils.toFormat(from90, 'yyyy-MM-DD');
        this.filters.date.end= this.$dateUtils.toFormat(today,'yyyy-MM-DD');
      },
      cancelEntity(entityId){
        this.$store.commit("purchase/cancel", entityId);
      },
      recoverEntity(entityId){
        this.$store.commit("purchase/recover", entityId);
      },
      getPurchases(){
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("purchase/load",{
          filters: this.filters,
          pagination:this.pagination
        });
      },
      uploadedResource(upload){
        if (upload['type'] == 'img') {
          this.$store.commit("purchase/appendImage", upload['entity']);
          return
        }
        this.$store.commit("purchase/appendDocument", upload['entity']);
      },
      removeResource(contract){
        if (contract['type'] == 'img') {
          this.$store.commit("purchase/removeImage", contract['entity']);
          return
        }
        this.$store.commit("purchase/removeDocument", contract['entity']);
      },
      loadResource(entity){
        this.entityId = entity._id
        this.entityNumber = entity.number
        this.$store.commit("purchase/resetResources");
        this.$store.commit("purchase/loadResource", entity._id);
      },
      goToDetalle(element){
        this.$router.push({ path: "/Operations/Purchases/PurchaseDetail/" + element._id});
      },
      importSuccess(){
        this.notificationInfo = {
          title: this.$t('key_mheader_purchase_imported'),
          message: this.$t('key_mmessage_purchase_imported'),
          status: 'success'
        }
        this.showNotification = true;
        this.closeNotification();
        setTimeout(() => {
          this.getPurchases();
        }, 3000)
      },
      importFailure(status){
        this.notificationInfo = {
          title: 'Ups! Error',
          message: status.error,
          status: 'error'
        }
        this.showNotification = true;
        this.closeNotification();
      },
      closeNotification(){
        const self = this;
        setTimeout(function () {
          self.showNotification = false
        }, 2700);
      },
      onSearchChange(value){
        this.pagination.currentPage = 1;
        this.filters.search=value;
        this.getPurchases(); 
      },
      paginationPageChange(page) {
        this.pagination.currentPage = page;
        this.getPurchases(); 
      },
      paginationRowChange(rows) {
        this.pagination.rows = rows;
        this.getPurchases(); 
      },
      onFilterChange(value){
        this.$router.replace({'query': {}})
        this.filterStatusSelected = value
        this.filters.status=value;
        this.getPurchases(); 
      },
      onDateFilterChange(value){
        this.filters.date.start= value.start
        this.filters.date.end= value.end
        this.getPurchases(); 
      },
      onFilterSgaRegisteredChange(value) {
        this.filters.sga_registered = value;
        this.getPurchases();
      },
      onDownloadExcel(){
        let savedLanguage = Cookies.get('Picko.language') || 'en';
        this.$store.commit("purchase/purchasesExcel", {filters: this.filters, language: savedLanguage});
      },
      downloadExcel(blob) {
        const link = document.createElement("a");
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().split('T')[0];
        link.setAttribute('download', `Purchases-${formattedDate}`);
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => {
            URL.revokeObjectURL(link.href);
        }, 100);
      },    
      onHeaderChange(val){
        this.filters.sort={
          sort: val.column,
          order: val.order=='asc'? "ascending": "descending"
        }
        this.getPurchases(); 
      },
      onCleanFilterDate(){
        this.defaultRangeDate();
        this.getPurchases(); 
      },
      confirmOnHoldStatus(data){
        this.$store.commit("purchase/onHoldStatus", data);
      } 
    }
  };

</script>

<style scoped>

  .units ul {
    list-style-type: none;
    padding: 0rem;
    margin-bottom: 0rem;
  }

  .columns {
    max-width: 150px;
  }

</style>